//
// import React, {useEffect, useState} from 'react';
// import Sidebar from './Sidebar';
// import Header from './Header';
// import {useDispatch, useSelector} from 'react-redux';
// import {closeSidebarOnMobile} from '@/store/slices/uiSlice';
// import {Outlet} from "react-router-dom";
//
// const Layout = () => {
//     const dispatch = useDispatch();
//     const { sidebarOpen } = useSelector((state) => state.ui);
//     const [isMobile, setIsMobile] = useState(false);
//
//     useEffect(() => {
//         const checkMobile = () => {
//             setIsMobile(window.innerWidth < 768);
//         };
//
//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []);
//
//     return (
//         <div className="h-screen bg-gray-50 flex overflow-hidden">
//             {/* Sidebar avec hauteur fixe */}
//             <Sidebar />
//
//             {/* Contenu principal */}
//             <div className="flex-1 flex flex-col h-screen overflow-hidden">
//                 {/* Header */}
//                 <Header />
//
//                 {/* Main content avec scroll vertical */}
//                 <main className="flex-1 overflow-y-auto p-4 md:p-6">
//                     <div className="max-w-7xl mx-auto">
//                         <Outlet />
//                     </div>
//                 </main>
//
//                 {/* Overlay mobile */}
//                 {sidebarOpen && isMobile && (
//                     <div
//                         className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
//                         onClick={() => dispatch(closeSidebarOnMobile())}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
//
// export default Layout;
import React, {useEffect, useState} from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import {useDispatch, useSelector} from 'react-redux';
import {setSidebarOpen} from '@/store/features/uiSlice';
import {Outlet} from "react-router-dom";
import {ChevronLeft, ChevronRight} from 'lucide-react';

const Layout = () => {
    const dispatch = useDispatch();
    const { sidebarCollapsed } = useSelector((state) => state.ui);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // La sidebar est TOUJOURS visible sur desktop, jamais cachée
    return (
        <div className="h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex overflow-hidden">
            {/* Sidebar - TOUJOURS visible sur desktop */}
            <div className={`
                transition-all duration-300 ease-in-out
                ${isMobile ? 'hidden' : 'flex'}
                ${sidebarCollapsed ? 'w-20' : 'w-64'}
                relative z-30
            `}>
                <Sidebar />
            </div>

            {/* Contenu principal */}
            <div className="flex-1 flex flex-col h-screen overflow-hidden min-w-0">
                {/* Header */}
                <div className="z-20">
                    <Header />
                </div>

                {/* Main content */}
                <main className="flex-1 overflow-y-auto p-4 md:p-6">
                    <div className={`
                        transition-all duration-300 ease-in-out
                     
             h-full
                    `}>
                        <Outlet />
                    </div>
                </main>

                {/* Mobile Menu Button - seulement sur mobile */}
                {isMobile && (
                    <button
                        onClick={() => dispatch(setSidebarOpen(true))}
                        className="
                            fixed bottom-6 right-6 z-50
                            p-4 rounded-full shadow-2xl
                            bg-gradient-to-r from-blue-600 to-blue-700
                            hover:from-blue-700 hover:to-blue-800
                            text-white transition-all duration-200
                            hover:shadow-xl hover:scale-110
                            lg:hidden
                        "
                    >
                        <ChevronRight size={24} />
                    </button>
                )}

                {/* Mobile Sidebar Slide-in */}
                {isMobile && (
                    <div className={`
                        fixed inset-y-0 left-0 z-50
                        transform transition-transform duration-300 ease-in-out
                        lg:hidden
                    `}>
                        <Sidebar />
                    </div>
                )}

                {/* Floating Toggle Button sur desktop seulement */}
                {!isMobile && (
                    <button
                        onClick={() => dispatch(toggleSidebarCollapsed())}
                        className="
                            fixed bottom-6 left-6 z-40
                            p-3 rounded-full shadow-xl
                            bg-gradient-to-r from-blue-600 to-blue-700
                            hover:from-blue-700 hover:to-blue-800
                            text-white transition-all duration-200
                            hover:shadow-2xl hover:scale-110
                            hidden lg:flex items-center justify-center
                        "
                        title={sidebarCollapsed ? "Agrandir" : "Réduire"}
                    >
                        {sidebarCollapsed ? (
                            <ChevronRight size={20} />
                        ) : (
                            <ChevronLeft size={20} />
                        )}
                    </button>
                )}
            </div>
        </div>
    );
};

export default Layout;